<template>
  <div id="app">
      <header class="level-right">
          <button id="loginBtn" class="button is-primary is-medium" @click="isComponentModalActive = true">Client Login</button>
          <a href="/admin" id="clientPortalBtn" class="button is-primary is-medium is-hidden" style="margin-right: 10px;">Client Portal</a>
          <a href="/" id="homeBtn" class="button is-primary is-medium is-hidden" style="margin-right: 10px;">Home</a>
          <button id="logoutBtn" class="button is-primary is-medium is-hidden" @click="logout()">Logout</button>

            <b-modal :active.sync="isComponentModalActive">
                <modal-form v-bind="formProps"></modal-form>
            </b-modal>
      </header>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import ModalForm from './components/ModalForm.vue'
import _ from 'lodash'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: 'app',
    components: {
        ModalForm
    },
    data() {
        return {
            isComponentModalActive: false,
            formProps: {
                email: '',
                password: ''
            }
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        logout() {
            firebase.auth().signOut();
            Toast.open({
                duration: 2000,
                message: `You've logged out successfully`,
                type: 'is-success'
            })
        }
    },
    mounted() {
        console.log(this.currentRouteName)
        firebase.auth().onAuthStateChanged(firebaseUser => {
            if (firebaseUser) {
                if (this.currentRouteName === 'Admin') {
                    document.getElementById('clientPortalBtn').classList.add('is-hidden');
                    document.getElementById('homeBtn').classList.remove('is-hidden');
                } else {
                    document.getElementById('clientPortalBtn').classList.remove('is-hidden');
                    document.getElementById('homeBtn').classList.add('is-hidden');
                }
                document.getElementById('loginBtn').classList.add('is-hidden');
                document.getElementById('logoutBtn').classList.remove('is-hidden');
                this.isComponentModalActive = false;
            } else {
                document.getElementById('loginBtn').classList.remove('is-hidden');
                document.getElementById('logoutBtn').classList.add('is-hidden');
                document.getElementById('clientPortalBtn').classList.add('is-hidden');
                document.getElementById('homeBtn').classList.add('is-hidden');
                this.$router.push('/');
            }
        });
    }
}
</script>

<style>
body {
  margin: 20px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFFFFF;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495E;
  color: #ffffff;
}

header {
    background-color: initial;
}

</style>



// WEBPACK FOOTER //
// App.vue?be7ed2c0